import { getDatetimeOrdinalSuffix } from '@/common/helpers';
import { DateTime } from 'luxon';

export const formatReportedAt = (reportedAt: string) => {
  const timestamp = DateTime.fromISO(reportedAt, { zone: 'America/Winnipeg' });
  // time in am/pm format
  const format1 = timestamp.toFormat('h:mm');
  // Remove all periods and make lowercase for am/pm
  const format2 = timestamp.toFormat('a').replace(/\./g, '');

  // day
  const format3 = timestamp.toFormat('EEEE d');
  const format4 = getDatetimeOrdinalSuffix(timestamp.day);

  // month
  const format5 = timestamp.toFormat('MMMM');

  return `${format1}${format2}, ${format3}${format4} ${format5}`;
};

export const formatDateTimeWithYear = (dateTime: string) => {
  const timestamp = DateTime.fromISO(dateTime, { zone: 'America/Winnipeg' });
  const format1 = timestamp.toFormat('h:mm');
  const format2 = timestamp.toFormat('a').replace(/\./g, '').toUpperCase();

  const format3 = timestamp.toFormat('DDDD');

  return `${format1} ${format2}, ${format3}.`;
};

/**
 * Formats a date that has no time of day, for example `12 July 2026`.
 * It reads the value in the `America/Winnipeg` zone, so a start-of-day value keeps its calendar date.
 * It uses the given locale for the month name. Without a locale, it uses the Luxon default locale.
 * It returns an empty string for a missing or invalid value.
 */
export const formatDateOnly = (date: string | undefined, locale?: string) => {
  if (!date) {
    return '';
  }

  const timestamp = DateTime.fromISO(date, { zone: 'America/Winnipeg', locale });

  return timestamp.isValid ? timestamp.toFormat('d LLLL yyyy') : '';
};
